/**
 * スマホのメニューバーを考慮したvhを利用するために実行
 */
export const setViewHeight = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}
